var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('OmniButton', {
    staticClass: "regenerate-trigger-cache",
    attrs: {
      "disabled": _vm.isRegenerateTriggerCacheButtonDisabled
    },
    on: {
      "click": _vm.regenerateTriggerCache
    }
  }, [_c('span', [_vm.processing ? [_c('span', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "sync-alt",
      "spin": ""
    }
  })], 1), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("omt.gui.triggers.status.refreshing-trigger-cache")))])] : [_c('span', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "sync-alt"
    }
  })], 1), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("omt.gui.triggers.action.refresh-trigger-cache")))])]], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }